import {
  FaBootstrap,
  FaCss3Alt,
  FaGithub,
  FaHtml5,
  FaLinkedinIn,
} from "react-icons/fa";
import { IoLogoFirebase, IoLogoJavascript } from "react-icons/io5";
import { RiReactjsLine } from "react-icons/ri";
import { SiTypescript, SiNpm, SiFigma, SiPostman, SiNvm, SiLeetcode } from "react-icons/si";
import {
  TbBrandNextjs,
  TbBrandTailwind,
  TbBrandRedux,
  TbBrandVite,
} from "react-icons/tb";
import { VscVscode } from "react-icons/vsc";

// cv
import cv from "../assets/cv.pdf";

// for project 1
import project1Img1 from "../assets/Project1/project1Img1.webp";
import project1Img2 from "../assets/Project1/project1Img2.webp";
import project1Img3 from "../assets/Project1/project1Img3.webp";
import project1Img4 from "../assets/Project1/project1Img4.webp";

// // for project 2
// import project2Img1 from "../assets/Project2/project2Img1.JPG";
// import project2Img2 from "../assets/Project2/project2Img2.JPG";

// for project 3
import project3Img1 from "../assets/Project3/1.webp";
import project3Img2 from "../assets/Project3/2.webp";
import project3Img3 from "../assets/Project3/3.webp";
import project3Img4 from "../assets/Project3/4.webp";
import project3Img5 from "../assets/Project3/5.webp";

// for project 4
import project4Img1 from "../assets/Project4/project4Img1.webp";
import project4Img2 from "../assets/Project4/project4Img2.webp";
import project4Img3 from "../assets/Project4/project4Img3.webp";

// for project 5
import project5Img1 from "../assets/Project5/project5Img1.webp";
import project5Img2 from "../assets/Project5/project5Img2.webp";
import project5Img3 from "../assets/Project5/project5Img3.webp";
import project5Img4 from "../assets/Project5/project5Img4.webp";
import project5Img5 from "../assets/Project5/project5Img5.webp";

// for project 6
import project6Img1 from "../assets/Project6/project6Img1.webp";
import project6Img2 from "../assets/Project6/project6Img2.webp";
import project6Img3 from "../assets/Project6/project6Img3.webp";
import project6Img4 from "../assets/Project6/project6Img4.webp";

// for project 7
import project7Img1 from "../assets/Project7/project7Img1.webp";
import project7Img2 from "../assets/Project7/project7Img2.webp";
import project7Img3 from "../assets/Project7/project7Img3.webp";

// for project 8
import project8Img1 from "../assets/Project8/project8Img1.webp";
import project8Img2 from "../assets/Project8/project8Img2.webp";
import project8Img3 from "../assets/Project8/project8Img3.webp";
import project8Img4 from "../assets/Project8/project8Img4.webp";
import project8Img5 from "../assets/Project8/project8Img5.webp";

// for project 9
import project9Img1 from "../assets/Project9/project9Img1.webp";
import project9Img2 from "../assets/Project9/project9Img2.webp";
import project9Img3 from "../assets/Project9/project9Img3.webp";
import project9Img4 from "../assets/Project9/project9Img4.webp";
import project9Img5 from "../assets/Project9/project9Img5.webp";
import project9Img6 from "../assets/Project9/project9Img6.webp";

// certificates
import certificate1 from "../assets/certificates/simplilearn.webp";
import certificate2 from "../assets/certificates/Software-Development-Certificate.webp";
import certificate3 from "../assets/certificates/css certificate-1.webp";
import certificate4 from "../assets/certificates/javascript_basic certificate-1.webp";
// import certificate5 from "../assets/certificates/JavaScript Algorithms and Data Structures Beta Certificate.webp";
import certificate6 from "../assets/certificates/Career-Skills-Certificate.webp";
import certificate7 from "../assets/certificates/CertificateOfCompletion_Practical GitHub Actions-1.webp";
import certificate8 from "../assets/certificates/CertificateOfCompletion_Programming Foundations Fundamentals-1.webp";
import certificate9 from "../assets/certificates/CertificateOfCompletion_What Is Generative AI.png";

// lightModeImg
import lightModeImg from "../assets/lightModeImg.webp";
import nightModeImg from "../assets/nightModeImg.webp";

// institutesImages
// import collegeLogo from "../assets/collegeLogo.png";
// import schoolLogo from "../assets/schoolLogo.jpeg";
import smitLogo from "../assets/smitLogo.webp";
import TTGLogo from "../assets/TTG-Logo.webp";
import universityLogo from "../assets/universityLogo.webp";

// navbarLogo
import navbarImg from "../assets/navbarLogo.jpeg";

const skillsSubTitle =
  "Curious coder on a mission to explore every corner of the tech world";

// name
const name = "Mukand Kirshna";

// navbarLogo
const navbarLogo = navbarImg;

// skillsIcons
const skillsIcons = [
  {
    icon: <FaHtml5 />,
    title: "Html-5",
    link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
    color: "#E34F26",
  },
  {
    icon: <FaCss3Alt />,
    title: "Css3",
    link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    color: "#1572B6",
  },
  {
    icon: <IoLogoJavascript />,
    title: "JavaScript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    color: "#F7DF1E",
  },
  {
    icon: <SiTypescript />,
    title: "Typescript",
    link: "https://www.typescriptlang.org/docs/",
    color: "#3178C6",
  },
  {
    icon: <FaBootstrap />,
    title: "Bootstrap",
    link: "https://getbootstrap.com/docs/",
    color: "#7952B3",
  },
  {
    icon: <TbBrandNextjs />,
    title: "Nextjs",
    link: "https://nextjs.org/docs",
    color: "#000000",
  },
  {
    icon: <RiReactjsLine />,
    title: "Reactjs",
    link: "https://react.dev/learn",
    color: "#61DAFB",
  },
  {
    icon: <TbBrandVite />,
    title: "Vite",
    link: "https://vitejs.dev/guide/",
    color: "#646CFF",
  },
  {
    icon: <TbBrandRedux />,
    title: "Redux",
    link: "https://redux.js.org/introduction/getting-started",
    color: "#764ABC",
  },
  {
    icon: <TbBrandTailwind />,
    title: "Tailwind css",
    link: "https://tailwindcss.com/docs",
    color: "#06B6D4",
  },
  {
    icon: <SiFigma />,
    title: "Figma",
    link: "https://help.figma.com/hc/en-us",
    color: "#F24E1E",
  },
  {
    icon: <IoLogoFirebase />,
    title: "Firebase",
    link: "https://firebase.google.com/docs",
    color: "#FFCA28",
  },
  {
    icon: <SiNpm />,
    title: "NPM",
    link: "https://docs.npmjs.com/",
    color: "#CB3837",
  },
  {
    icon: <SiNvm />,
    title: "NVM",
    link: "https://github.com/nvm-sh/nvm#readme",
    color: "#3C873A",
  },
  {
    icon: <SiPostman />,
    title: "Postman",
    link: "https://learning.postman.com/docs/getting-started/introduction/",
    color: "#FF6C37",
  },
  {
    icon: <VscVscode />,
    title: "VS code",
    link: "https://code.visualstudio.com/docs",
    color: "#007ACC",
  },
];

// education
const education = [
  // {
  //   img: schoolLogo,
  //   instituteName: "AJM Govt: Boys High School Mithi",
  //   degreeName: "Matriculation",
  //   duration: "july 2017",
  // },
  // {
  //   img: collegeLogo,
  //   instituteName: "Government Boys Degree College Mithi",
  //   degreeName: "Intermediate",
  //   duration: "july 2019",
  // },
  {
    img: universityLogo,
    instituteName: "University of Sindh",
    degreeName: "AD Commerce 2 years Degree",
    duration: "March 2023",
  },

  {
    img: smitLogo,
    instituteName: "Saylani Mass IT Training Program",
    degreeName: "Web Development Course",
    duration: "June 2023",
    certified: false,
  },
];

const certifications = [
  {
    img: certificate1,
    certificateProvider: "simplilearn",
    certificationName: "Front End Development",
    issuedDate: "June 2025",
    link: "https://simpli-web.app.link/e/GoxL2WkFvUb",
  },
  {
    img: certificate2,
    certificateProvider: "linkedin-learning",
    certificationName: "Software Development",
    issuedDate: "December 2025",
    link: "https://www.linkedin.com/learning/certificates/265c812fc2615f6281b4327d14974173cefcdd23c4ff439d7143d9c38580f7a2?trk=share_certificate", // example
  },
  {
    img: certificate3,
    certificateProvider: "hackerrank",
    certificationName: "CSS",
    issuedDate: "May 2025",
    link: "https://www.hackerrank.com/certificates/1b8aa5937f7a",
  },
  {
    img: certificate4,
    certificateProvider: "hackerrank",
    certificationName: "JavaScript",
    issuedDate: "May 2025",
    link: "https://www.hackerrank.com/certificates/5582854d8d94",
  },
  {
    img: certificate6,
    certificateProvider: "linkedin-learning",
    certificationName: "Career Skills",
    issuedDate: "December 2025",
    link: "https://www.linkedin.com/learning/certificates/265c812fc2615f6281b4327d14974173cefcdd23c4ff439d7143d9c38580f7a2?trk=share_certificate",
  },
  {
    img: certificate7,
    certificateProvider: "LinkedIn Learning",
    certificationName: "Practical GitHub Actions",
    issuedDate: "June 2025",
    link: "https://www.linkedin.com/learning/certificates/72c1cdd215ded27511b0b40ccf6bc4c0fa09c9a6abe3b1342b2104f572effc68?trk=share_certificate",
  },
  {
    img: certificate8,
    certificateProvider: "LinkedIn Learning",
    certificationName: "Programming Foundations: Fundamentals",
    issuedDate: "June 2025",
    link: "https://www.linkedin.com/learning/certificates/9dc6c20f8ecd4c5994b122f07763ec0ade610a54f5ce8e5a828e2c8ca2140b1e?trk=share_certificate",
  },
  {
    img: certificate9,
    certificateProvider: "LinkedIn Learning",
    certificationName: "What Is Generative AI",
    issuedDate: "July 2026",
    link: "https://www.linkedin.com/learning/certificates/03fdd33cd07f120e333284bed004f415b6f23d2a293eb5406288f6dd9de538f4?trk=share_certificate",
  },
];

// resumeLink
const resume = cv;
// const resume = "https://drive.google.com/fi/le/d/1qQI_0lC0Sb-tmoMS5ZrvwonM-bkH6c9m/view?usp=sharing";

// professionalExperience
const professionalExperience = [
  {
    img: TTGLogo,
    name: "The Talent Games",
    role: "Frontend Web Developer",
    duration: "June 2024",
    certified: false,
  },
  {
    img: smitLogo,
    name: "Saylani Mass IT Training Program",
    role: "Trainer Assistant for Web Development Course",
    duration: "January 2024",
    certified: false,
  },
];

// skillsList
const skillsList = [
  "Develop highly interactive Front-end / User Interfaces for your websites.",
  "Integration of third party services such as Firebase.",
  "Easily create responsive sites.",
];

// servicesList
const servicesList = [
  {
    title: "Frontend Development",
    description:
      "Specialize in frontend development by building user interfaces (UIs) and user experiences (UX) using HTML5, CSS3, JavaScript, and React.js. Develop single-page applications (SPAs) and ensure they are fast, responsive, and accessible.",
  },
  {
    title: "Website Development",
    description:
      "Create responsive and interactive websites for individuals, businesses, or organizations using your skills in HTML5, CSS3, JavaScript, and Bootstrap. Ensure that the websites are mobile-friendly and optimized for various devices and screen sizes.",
  },
  // {
  //   title: "Version Control with Git",
  //   description:
  //     "Implement Git for efficient code management and collaboration, ensuring smooth development workflows and version tracking.",
  // },

  {
    title: "Web Hosting and Deployment",
    description:
      "Assist clients in deploying their websites and web applications to hosting platforms such as Firebase Hosting, Netlify, or traditional web servers. Optimize website performance and ensure secure connections (HTTPS).",
  },
  {
    title: "Maintenance and Updates",
    description:
      "Offer maintenance services to keep websites and web applications up-to-date with security patches, performance improvements, and feature enhancements. Provide regular backups and monitoring for uptime.",
  },
  {
    title: "Responsive Design Audits",
    description:
      "Evaluate existing websites for responsiveness across devices and browsers. Provide recommendations and implement improvements using CSS3 media queries and responsive design principles.",
  },
  {
    title: "Integration with APIs",
    description:
      "Integrate third-party APIs (such as social media APIs, or data APIs) into web applications using JavaScript and frameworks like React.js. Ensure secure and efficient data exchange between systems.",
  },
];

// portfolio
const portfolio = [
  {
    images: [project6Img1, project6Img2, project6Img3, project6Img4],
    title: "Admin-Dashboard",
    description:
      "Built a customizable Admin Dashboard using React and JavaScript. Implemented new features for data visualization, user management, and real-time updates. Emphasized clean UI design, responsive layouts, and maintainable code structure. Incorporated best practices in component-based architecture to streamline development and future scalability.",
    link: "https://admin-dashboard-80.vercel.app/",
  },
  {
    images: [
      project8Img1,
      project8Img2,
      project8Img3,
      project8Img4,
      project8Img5,
    ],
    title: "Animate-Land",
    description:
      "Animated-Land is a creative web space built with React.js, where smooth animations and interactive design come together to bring ideas to life. Focused on simplicity, speed, and modern aesthetics, this site blends technology with imagination for a seamless browsing experience.",
    link: "https://animate-land-website.vercel.app/",
  },
  {
    images: [
      project9Img1,
      project9Img2,
      project9Img3,
      project9Img4,
      project9Img5,
      project9Img6,
    ],
    title: "Movies App",
    description:
      "Built with React, styled using Tailwind CSS, and powered by The Movie Database (TMDb) API, Movies App is a sleek and responsive web application that lets users browse and watch trailers of the latest, trending, and top-rated movies — all in one place",
    link: "https://screenverse-ui.vercel.app/",
  },
  {
    images: [
      project3Img1,
      project3Img2,
      project3Img3,
      project3Img4,
      project3Img5,
    ],
    title: "Dev Blog",
    description:
      "This is a blog website built using Next.js and TypeScript. It supports dynamic routing to display individual blog posts. The project is structured for easy content management and provides a fast, responsive user experience.",
    github: "https://github.com/mukand-mapara/blog-website",
  },
  {
    images: [project1Img1, project1Img2, project1Img3, project1Img4],
    title: "E-commerce-web",
    description:
      "This e-commerce website is a highly functional and visually appealing platform designed to deliver a seamless and engaging shopping experience.  user-first approach, it combines outstanding performance, elegant aesthetics, and intuitive usability to cater to diverse customer needs.",
    link: "https://e-commerce-web-lemon.vercel.app/",
  },
  {
    images: [project7Img1, project7Img2, project7Img3],
    title: "Job Portal",
    description:
      "Built a job portal using React and Firebase where users can search for jobs, apply online, upload resumes, and track their applications.",
    link: "https://job-portal-zeta-peach.vercel.app/",
  },
  {
    images: [project4Img1, project4Img2, project4Img3],
    title: "React Demo Web-Page",
    description:
      "This React demo website showcases a modern and clean interface with a focus on responsive design and intuitive user experience. It includes a fully responsive layout that adapts seamlessly to various screen sizes, ensuring a consistent appearance on desktops, tablets, and mobile devices.",
    link: "https://react-demo-website.vercel.app/",
  },
  {
    images: [
      project5Img1,
      project5Img2,
      project5Img3,
      project5Img4,
      project5Img5,
    ],
    title: "Restaurant Hub",
    description:
      "Restaurant Hub is a visually captivating platform designed to connect food lovers with their favorite dining spots effortlessly. This project combines functionality and aesthetics to create an intuitive experience for users exploring restaurant menus, reviews, and reservations.",
    link: "https://restaurant-website-eight-iota.vercel.app/",
  },
  // {
  //   images: [project2Img1, project2Img2],
  //   title: "Expense Management System",
  //   description:
  //     "A React and Redux-based web app for tracking and managing expenses. It offers features like adding, editing, and deleting expenses with categorized views, ensuring a seamless and responsive user experience.",
  //   link: "https://expense-management-delta.vercel.app/",
  // },
];

// contact
const contact = {
  whatsapp: "+92333-2548247",
  number: "+92333-2548247",
  email: "mukandkirshana1606@gmail.com",
  location: "Newtown jail chowrangi Karachi",
};

// socialLinks
const socialLinks = [
  {
    icon: <FaGithub />,
    link: "https://github.com/mukand-mapara",
  },
  {
    icon: <FaLinkedinIn />,
    link: "https://www.linkedin.com/in/mukand-kirshana/",
  },
  {
    icon: <SiLeetcode />,
    link: "https://leetcode.com/u/Mukand-Mapara/",
  },
];

const themes = {
  lightModeImg,
  nightModeImg,
};

export {
  contact,
  education,
  name,
  navbarLogo,
  portfolio,
  professionalExperience,
  resume,
  servicesList,
  skillsIcons,
  skillsList,
  skillsSubTitle,
  socialLinks,
  themes,
  certifications,
};
